import React from "react";
import Table from "../components/Table";
import Paymentbox from "../components/PaymentInfobox";
import Leaderslist from "../components/Leaderslist";
import TableSorting from "../components/TableSorting";
import ObjectiveBox from "../components/ObjectiveBox";

const Summery = () => (


    <>
    <Table />

    <Paymentbox />

    <Leaderslist />

   

    <div className="objective-box d-flex">
        <div className="table-main-left">
            <TableSorting />
        </div>
        <div className="box-main">
        <ObjectiveBox />
        </div>

    </div>

    </>
);

export default Summery;
